'use client'
import * as React from 'react'
import { BaseHubAvatar } from '~/components/basehub-avatar'
import { getDefaultAvatarSrc } from '@basehub/data/auth/utils/avatar'
import { useSelectedTeam } from '~/hooks-data/use-selected-team'
import { Container } from '~/sotano-kit/primitives/container'
import { Heading } from '~/sotano-kit/primitives/heading'
import {
  PublicTeam,
  isUserTeam,
} from '@basehub/data/replicache/mutators/_public-types'
import { useUserStore } from '~/app/_store/user-store'
import { Team } from '@basehub/data/replicache/index'

export const DashboardHeader = ({
  staticTeamData,
}: {
  staticTeamData?: PublicTeam | Team
}) => {
  const { team, isLoading } = useSelectedTeam(staticTeamData)
  const user = useUserStore((s) => s.optimisticUser)
  const plan = isUserTeam(team) && (team.plan_v2?.type || team.plan!)
  return (
    <div>
      <Container
        size="xl"
        className="-mt-header flex h-dashboard-header items-center space-x-6 pb-12 pt-[88px]"
      >
        {isLoading || !team || (!user && isUserTeam(team)) ? (
          <div className="relative w-20 h-20 overflow-hidden border rounded-full border-dark-border-solid before:absolute before:inset-0 before:-translate-x-full before:animate-loading-skeleton before:bg-loading" />
        ) : (
          <BaseHubAvatar
            withBorder
            name={team.title}
            id={team.id}
            size="large"
            forceSrc={
              plan === 'personal' && user
                ? user.imageUrl
                  ? user.imageUrl
                  : getDefaultAvatarSrc(user.id)
                : (team.avatarUrl ?? getDefaultAvatarSrc(team.id))
            }
          />
        )}

        <div className="flex flex-col space-y-1.5">
          {isLoading || !team ? (
            <div className="flex items-center space-x-2">
              <div className="relative h-[26px] w-40 overflow-hidden rounded-lg border border-white/10 before:absolute before:inset-0 before:-translate-x-full before:animate-loading-skeleton before:bg-loading" />
              <div className="relative w-16 h-5 overflow-hidden border rounded-lg border-white/10 before:absolute before:inset-0 before:-translate-x-full before:animate-loading-skeleton before:bg-loading" />
            </div>
          ) : (
            <div className="inline-flex items-center">
              <Heading as="h1" size="mini">
                {team.title}
              </Heading>
            </div>
          )}

          {isLoading || !team ? (
            <div className="relative h-4 overflow-hidden border rounded-lg w-36 border-white/10 before:absolute before:inset-0 before:-translate-x-full before:animate-loading-skeleton before:bg-loading" />
          ) : (
            team.description && (
              <h2 className="text-sm text-dark-muted max-w-[620px] leading-snug line-clamp-2">
                {team.description}
              </h2>
            )
          )}
        </div>
      </Container>
    </div>
  )
}
